module.exports = __webpack_public_path__ + "static/favicon-b9f870ed5a3d0ef78eb71c266ea11be5.png";